export default "__VITE_ASSET__IvYAH3rH__"